/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.15.2
 */

import split from 'lodash/split';

export function htmlTranslationFormat(str = '', params: { [key: string]: JSX.Element }) {
    return split(str, /{(.*?)}+/g).reduce((elementList: any[], element) => {
        elementList.push(params[element] || <span dangerouslySetInnerHTML={{ __html: element }}/>);
        elementList.push(' ');
        return elementList;
    }, []);
}
